import { trackingService } from "../../../common/services/tracking.service";
import { URL_PARAMETERS } from "../../../common/utils/const.util";
import {
  getUrlParameterValue,
  setUrlParameter,
} from "../../../common/utils/url.util";

export class ParentService {
  public static addEventListeners() {
    const userTypeItems = $(".user-type li");

    userTypeItems.on("click", (event) => {
      const currentTarget = event.currentTarget as HTMLElement;
      if (!this.isSelectableUserType(currentTarget)) {
        return;
      }

      this.handleUserTypeSelection(currentTarget);
    });

    userTypeItems
      .filter((_index, element) =>
        this.isSelectableUserType(element as HTMLElement)
      )
      .on("keydown", (event) => {
        const keyboardEvent = event as JQuery.KeyDownEvent;
        if (
          keyboardEvent.key === "Enter" ||
          keyboardEvent.key === " " ||
          keyboardEvent.key === "Spacebar"
        ) {
          keyboardEvent.preventDefault();
          (keyboardEvent.currentTarget as HTMLElement).click();
        }
      });
  }

  private static isSelectableUserType(target: HTMLElement): boolean {
    return $(target).find("a").length === 0;
  }

  private static handleUserTypeSelection(target: HTMLElement): void {
    const isRegistered = $(target).hasClass("registered");

    trackingService.pushEvent("ryb_user_type_selected", {
      user_type: isRegistered ? "registered" : "new",
    });

    setUrlParameter(URL_PARAMETERS.USER, isRegistered.toString());
    setUrlParameter(URL_PARAMETERS.STEP, "1");
    this.nextStepEvents();
  }

  public static nextStepEvents() {
    $(".box.show").removeClass("show");
    $(".box.child").addClass("show");

    const isRegistered = getUrlParameterValue(URL_PARAMETERS.USER) === "false";
    if (isRegistered) {
      $(".box.child .form-box").addClass("show");
    }
  }
}
